/* ==========================================================================
   Kirlune · Parches para ojeras
   Acordeones, selector de fórmula, packs, galería, barra fija y revelados.
   Sin dependencias: vanilla.
   ========================================================================== */
(function () {
  "use strict";

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  };

  /* ------------------------------------------------------------ acordeón */
  function faq() {
    $$(".av-faq__q").forEach(function (btn) {
      if (btn.dataset.avListo) return;
      btn.dataset.avListo = "1";
      btn.addEventListener("click", function () {
        var item = btn.closest(".av-faq__item");
        var grupo = btn.closest(".av-faq");
        var abierto = item.classList.contains("is-open");
        if (grupo && grupo.dataset.single === "true") {
          $$(".av-faq__item", grupo).forEach(function (i) {
            i.classList.remove("is-open");
            var q = $(".av-faq__q", i);
            if (q) q.setAttribute("aria-expanded", "false");
          });
        }
        item.classList.toggle("is-open", !abierto);
        btn.setAttribute("aria-expanded", String(!abierto));
      });
    });
  }

  /* ------------------------------------------------------------ galería */
  function galeria(raiz) {
    var main = $("[data-av-gal-main]", raiz);
    if (!main) return;
    $$("[data-av-gal-thumb]", raiz).forEach(function (t) {
      t.addEventListener("click", function () {
        main.src = t.getAttribute("data-av-gal-thumb");
        $$("[data-av-gal-thumb]", raiz).forEach(function (o) { o.classList.remove("is-on"); });
        t.classList.add("is-on");
      });
    });
  }

  /* -------------------------------------------- variantes (fórmula) + packs */
  function compra(raiz) {
    var datos = $("[data-av-variants]", raiz);
    if (!datos) return;

    var lista;
    try { lista = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!lista || !lista.length) return;

    var campoId = $('input[name="id"]', raiz);
    var campoQty = $('input[name="quantity"]', raiz);
    var pAhora = $("[data-av-precio]", raiz);
    var pAntes = $("[data-av-antes]", raiz);
    var pOff = $("[data-av-off]", raiz);
    var boton = $("[data-av-submit]", raiz);
    var etiqueta = boton ? boton.getAttribute("data-av-label") : "AGREGAR AL CARRITO";
    var galMain = $("[data-av-gal-main]", raiz);
    var nombreOpcion = $("[data-av-op-valor]", raiz);

    function variante() {
      var marcado = $("[data-av-op] input:checked", raiz);
      var valor = marcado ? marcado.value : null;
      for (var i = 0; i < lista.length; i++) {
        if (valor === null || lista[i].options[0] === valor) return lista[i];
      }
      return lista[0];
    }

    function pack() {
      var p = $("[data-av-pack] input:checked", raiz);
      return p ? parseInt(p.value, 10) || 1 : 1;
    }

    function pinta() {
      var v = variante();
      var n = pack();
      if (!v) return;

      if (campoId) campoId.value = v.id;
      if (campoQty) campoQty.value = n;
      if (nombreOpcion) nombreOpcion.textContent = v.options[0];

      /* Los precios los formatea Liquid y vienen ya en la moneda que ve la
         persona. Calcularlos aquí desde los céntimos daría la moneda de la
         tienda y se rompería para quien navegue en otra divisa. */
      if (pAhora) pAhora.textContent = n > 1 ? multiplica(v.price_money, n) : v.price_money;
      if (pAntes && v.compare_money) {
        pAntes.textContent = n > 1 ? multiplica(v.compare_money, n) : v.compare_money;
        pAntes.style.display = v.compare_at_price > v.price ? "" : "none";
      }
      if (pOff) {
        if (v.compare_at_price > v.price) {
          pOff.textContent = "-" + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + "%";
          pOff.style.display = "";
        } else { pOff.style.display = "none"; }
      }

      if (boton) {
        boton.disabled = !v.available;
        boton.textContent = v.available ? etiqueta : "Agotado";
      }
      if (galMain && v.featured_image) galMain.src = v.featured_image;
    }

    /* Multiplica un precio ya formateado ("$29,99") conservando su formato.
       Solo toca los dígitos, así que respeta símbolo, comas y puntos. */
    function multiplica(txt, n) {
      if (!txt) return txt;
      var m = txt.match(/[\d.,]+/);
      if (!m) return txt;
      var crudo = m[0];
      var decimal = crudo.lastIndexOf(",") > crudo.lastIndexOf(".") ? "," : ".";
      var limpio = crudo.replace(decimal === "," ? /\./g : /,/g, "").replace(",", ".");
      var total = (parseFloat(limpio) * n);
      if (isNaN(total)) return txt;
      var salida = total.toFixed(2);
      if (decimal === ",") salida = salida.replace(".", ",");
      return txt.replace(crudo, salida);
    }

    $$("[data-av-op] input, [data-av-pack] input", raiz).forEach(function (input) {
      input.addEventListener("change", function () {
        var cont = input.closest("[data-av-op], [data-av-pack]");
        var clase = cont.hasAttribute("data-av-pack") ? ".av-pack" : ".av-op__b";
        $$(clase, cont.parentElement).forEach(function (el) {
          el.classList.toggle("is-on", el.contains(input));
        });
        pinta();
      });
    });

    pinta();
  }

  /* ---------------------------------------------------------- barra fija */
  function sticky() {
    var barra = $("[data-av-sticky]");
    if (!barra) return;
    var ancla = $("[data-av-sticky-anchor]");

    var mira = function () {
      if (!ancla) { barra.classList.toggle("is-up", window.scrollY > 700); return; }
      barra.classList.toggle("is-up", ancla.getBoundingClientRect().bottom < 0);
    };
    mira();
    window.addEventListener("scroll", mira, { passive: true });
    window.addEventListener("resize", mira);

    var ir = $("[data-av-sticky-go]", barra);
    if (ir) {
      ir.addEventListener("click", function () {
        var form = $("[data-av-form]");
        if (!form) return;
        var b = $("[data-av-submit]", form);
        if (b) b.click();
      });
    }
  }

  /* ---------------------------------------------------- revelado al entrar */
  function revelar() {
    var items = $$(".av-rev-in");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (i) { i.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ------------------------------------------------- datos fiscales (MX) */
  /* Guarda RFC/CURP como ATRIBUTOS DEL PEDIDO. En el plan Basic no se pueden
     anadir campos dentro del checkout (eso es solo Plus), asi que el dato se
     recoge en el carrito y viaja con el pedido. */
  function fiscal() {
    var zona = $("[data-av-fiscal]");
    if (!zona || zona.dataset.avListo) return;
    zona.dataset.avListo = "1";

    var toggle = $("[data-av-fiscal-toggle]", zona);
    var campos = $("[data-av-fiscal-campos]", zona);
    var estado = $("[data-av-fiscal-estado]", zona);
    var temporizador = null;

    function mostrar() {
      campos.hidden = !toggle.checked;
      guarda();
    }

    function valida() {
      var ok = true;
      $$("[data-av-attr]", zona).forEach(function (i) {
        var err = i.parentElement.querySelector("[data-av-error]");
        if (i.getAttribute("data-av-attr") !== "RFC") return;
        var v = i.value.trim().toUpperCase();
        var bien = v === "" || v.length === 12 || v.length === 13;
        i.classList.toggle("av-mal", !bien);
        if (err) err.hidden = bien;
        if (!bien) ok = false;
      });
      return ok;
    }

    function guarda() {
      if (!valida()) return;
      var attrs = { "Necesito factura": toggle.checked ? "Sí" : "" };
      $$("[data-av-attr]", zona).forEach(function (i) {
        attrs[i.getAttribute("data-av-attr")] = toggle.checked ? i.value.trim() : "";
      });
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () {
        if (estado && toggle.checked) {
          estado.classList.add("av-ok");
          estado.textContent = "Guardado. Estos datos viajan con tu pedido.";
        }
      }).catch(function () {});
    }

    toggle.addEventListener("change", mostrar);
    $$("[data-av-attr]", zona).forEach(function (i) {
      i.addEventListener("input", function () {
        clearTimeout(temporizador);
        temporizador = setTimeout(guarda, 600);
      });
      i.addEventListener("blur", guarda);
    });

    campos.hidden = !toggle.checked;
  }

  /* ------------------------------------------- carrusel de videos (movil) */
  function videos() {
    /* Solo reproduce el video que se esta viendo. Si se dejan los tres
       corriendo a la vez, el movil gasta bateria y datos para nada. */
    var reproductores = $$("[data-av-video]");
    if (reproductores.length && "IntersectionObserver" in window) {
      var ioV = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      reproductores.forEach(function (v) { ioV.observe(v); });
    }

    $$("[data-av-carrusel]").forEach(function (car) {
      if (car.dataset.avListo) return;
      car.dataset.avListo = "1";

      var pista = $("[data-av-pista]", car);
      var puntos = $$("[data-av-punto]", car);
      if (!pista) return;

      var quieto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var auto = car.getAttribute("data-av-auto") === "1" && !quieto;
      var espera = (parseInt(car.getAttribute("data-av-seg"), 10) || 6) * 1000;
      var reloj = null;
      var pausadoHasta = 0;

      function slides() { return $$("[data-av-slide]", pista); }

      function actual() {
        var s = slides();
        if (!s.length) return 0;
        var centro = pista.scrollLeft + pista.clientWidth / 2;
        var mejor = 0, dist = Infinity;
        s.forEach(function (el, i) {
          var c = el.offsetLeft + el.offsetWidth / 2;
          var d = Math.abs(c - centro);
          if (d < dist) { dist = d; mejor = i; }
        });
        return mejor;
      }

      function irA(i) {
        var s = slides();
        if (!s.length) return;
        i = ((i % s.length) + s.length) % s.length;
        var el = s[i];
        pista.scrollTo({
          left: el.offsetLeft - (pista.clientWidth - el.offsetWidth) / 2,
          behavior: quieto ? "auto" : "smooth"
        });
      }

      function pintaPuntos() {
        var i = actual();
        puntos.forEach(function (p, j) { p.classList.toggle("is-on", j === i); });
      }

      function avanza() {
        if (Date.now() < pausadoHasta) return;
        /* solo tiene sentido si de verdad hay algo que desplazar (movil) */
        if (pista.scrollWidth <= pista.clientWidth + 4) return;
        irA(actual() + 1);
      }

      if (auto) reloj = setInterval(avanza, espera);

      /* Si la persona toca el carrusel, se para un rato: no hay nada mas
         molesto que un carrusel que te quita el video de delante. */
      var frena = function () { pausadoHasta = Date.now() + espera * 2; };
      ["pointerdown", "touchstart", "wheel"].forEach(function (ev) {
        pista.addEventListener(ev, frena, { passive: true });
      });

      var t = null;
      pista.addEventListener("scroll", function () {
        clearTimeout(t);
        t = setTimeout(pintaPuntos, 90);
      }, { passive: true });

      puntos.forEach(function (p) {
        p.addEventListener("click", function () {
          frena();
          irA(parseInt(p.getAttribute("data-av-punto"), 10) || 0);
        });
      });

      /* si la pestana se va a segundo plano, no seguimos pasando videos */
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) { if (reloj) { clearInterval(reloj); reloj = null; } }
        else if (auto && !reloj) { reloj = setInterval(avanza, espera); }
      });

      pintaPuntos();
    });
  }

  /* --------------------------------------------- carrito lateral (cajon) */
  /* Nuestra ficha usa un formulario propio, no el <product-form> de Dawn, asi
     que el envio se intercepta aqui: se anade con fetch y se pinta el cajon
     que Dawn ya trae. Si algo falla, se deja que el formulario haga lo de
     siempre (ir a la pagina del carrito), para no dejar a nadie sin comprar. */
  function cajon() {
    var caja = document.querySelector("cart-drawer");
    if (!caja) return;

    /* el icono de la cabecera abre el cajon en vez de ir a /cart */
    var enlace = $(".av-head__cesta");
    if (enlace) {
      enlace.setAttribute("role", "button");
      enlace.setAttribute("aria-haspopup", "dialog");
      enlace.addEventListener("click", function (e) {
        e.preventDefault();
        caja.open(enlace);
      });
    }

    var hueco = enlace ? $("span", enlace) : null;

    /* Refresca el contador de la cabecera y, sobre todo, quita o pone la clase
       `is-empty` del <cart-drawer>. Dawn solo se la quita al .drawer__inner,
       no al elemento de fuera, y con ella puesta su CSS esconde la cabecera del
       cajon (con la X de cerrar) y convierte el interior en una rejilla
       centrada: el cajon se abre con pinta de vacio aunque tenga productos. */
    function repasa() {
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (hueco) hueco.textContent = c.item_count;
          caja.classList.toggle("is-empty", c.item_count === 0);
          return c;
        })
        .catch(function () {});
    }

    /* Cualquier cambio dentro del cajon (cambiar cantidad, quitar una linea)
       lo hace el JS de Dawn por su cuenta, sin avisarnos. Se vigila el cajon
       para mantener el contador y el `is-empty` al dia. */
    var reloj;
    new MutationObserver(function () {
      clearTimeout(reloj);
      reloj = setTimeout(repasa, 200);
    }).observe(caja, { childList: true, subtree: true });

    /* Vuelve a pedir el cajon entero al servidor y lo repinta. Se usa tras
       tocar el seguro de envio o anadir un producto sugerido: los dos cambian
       el carrito por detras y hay que redibujar. */
    function repinta() {
      return fetch("/?sections=cart-drawer,cart-icon-bubble")
        .then(function (r) { return r.json(); })
        .then(function (secciones) {
          caja.classList.remove("is-empty");
          caja.renderContents({ sections: secciones });
          return repasa();
        })
        .catch(function () { window.location.reload(); });
    }

    /* Los dos siguientes van delegados en `document` a proposito: el cajon se
       redibuja entero en cada cambio, asi que un listener puesto en el propio
       boton se perderia en el primer refresco. */

    document.addEventListener("change", function (ev) {
      var casilla = ev.target;
      if (!casilla || !casilla.matches || !casilla.matches("[data-av-seg-toggle]")) return;
      var id = casilla.dataset.variantId;
      if (!id) return;

      var marco = casilla.closest("[data-av-seg]");
      if (marco) marco.style.opacity = ".5";
      casilla.disabled = true;

      var peticion = casilla.checked
        ? { url: "/cart/add.js", cuerpo: { items: [{ id: id, quantity: 1 }] } }
        : { url: "/cart/change.js", cuerpo: { id: id, quantity: 0 } };

      fetch(peticion.url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(peticion.cuerpo)
      }).then(repinta).catch(repinta);
    });

    document.addEventListener("click", function (ev) {
      var btn = ev.target.closest ? ev.target.closest("[data-av-fbt-add]") : null;
      if (!btn || btn.disabled) return;
      ev.preventDefault();

      var id = btn.getAttribute("data-av-fbt-add");
      if (!id) return;
      var etiqueta = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Añadiendo…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(repinta)
        .catch(function () { window.location.reload(); })
        .then(function () {
          btn.disabled = false;
          btn.textContent = etiqueta;
        });
    });

    $$("[data-av-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var boton = $("[data-av-submit]", form);
        if (boton) boton.setAttribute("aria-disabled", "true");

        var datos = new FormData(form);
        datos.append("sections", caja.getSectionsToRender().map(function (x) { return x.id; }));
        datos.append("sections_url", window.location.pathname);
        if (caja.setActiveElement) caja.setActiveElement(document.activeElement);

        var url = (window.routes && window.routes.cart_add_url) || "/cart/add.js";
        fetch(url, {
          method: "POST",
          headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
          body: datos
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            /* si Shopify devuelve un error trae "status"; ahi no hay cajon que
               pintar, asi que se envia el formulario a pelo y que lo cuente la
               pagina del carrito */
            if (res.status) { form.submit(); return; }
            caja.classList.remove("is-empty");
            caja.renderContents(res);
            repasa();
          })
          .catch(function () { form.submit(); })
          .then(function () {
            if (boton) boton.removeAttribute("aria-disabled");
          });
      });
    });
  }

  /* ------------------------------------------- menu desplegable en movil */
  function menu() {
    var boton = $("[data-av-menu]");
    if (!boton) return;
    var cabecera = boton.closest(".av-head");
    if (!cabecera) return;

    function abre(si) {
      cabecera.classList.toggle("is-open", si);
      boton.setAttribute("aria-expanded", si ? "true" : "false");
    }

    boton.addEventListener("click", function (e) {
      e.stopPropagation();
      abre(!cabecera.classList.contains("is-open"));
    });

    /* al tocar un enlace se cierra: si no, el panel se queda abierto tapando
       la pagina a la que acaba de ir */
    $$(".av-head__nav a").forEach(function (a) {
      a.addEventListener("click", function () { abre(false); });
    });

    document.addEventListener("click", function (e) {
      if (!cabecera.contains(e.target)) abre(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") abre(false);
    });
  }

  function boot() {
    try { faq(); } catch (e) {}
    try { menu(); } catch (e) {}
    try { sticky(); } catch (e) {}
    try { revelar(); } catch (e) {}
    try { fiscal(); } catch (e) {}
    try { videos(); } catch (e) {}
    try { cajon(); } catch (e) {}
    $$("[data-av-buy]").forEach(function (raiz) {
      try { galeria(raiz); } catch (e) {}
      try { compra(raiz); } catch (e) {}
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else { boot(); }

  document.addEventListener("shopify:section:load", boot);
})();
